import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { ChatReducer } from "./chat.reducer";
import { ConfigReducer } from "./config.reducer";
import { NotificationReducer } from "./notification.reducer";
import { SessionReducer } from "./session.reducer";

const typeWindow = window as unknown as { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: typeof compose };

const composeEnhancers = typeWindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// 配置持久化
const persistConfig = {
    key: 'root',
    storage,
    // 只持久化session数据，其他数据不需要持久化
    whitelist: ['session']
};

const sessionPersistConfig = {
    key: 'session',
    storage,
    // 只持久化预填表单；currentPhase 不持久化，避免关微信后误进聊天窗
    whitelist: ['preEngagementData']
};

const reducers = combineReducers({
    chat: ChatReducer,
    config: ConfigReducer,
    notifications: NotificationReducer,
    session: persistReducer(sessionPersistConfig, SessionReducer)
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(thunk)));
export const persistor = persistStore(store);
